import { DemandWidgetDTO, DemandStatus } from 'entities/demand';
import { DataType } from './DemandWidget.types';

export const mapDataToTableColumns = (mappedData: DemandWidgetDTO[]): DataType[] => {
  return mappedData?.map(
    ({
      positionName,
      accountLogo,
      accountName,
      demandStatus,
      demandRecruiterPictureUrl,
      demandRecruiterLastName,
      demandRecruiterFirstName,
      ...demandData
    }) => ({
      ...demandData,
      demandData: { positionName, accountLogo, accountName, demandStatus },
      demandRecruiter: { demandRecruiterPictureUrl, demandRecruiterLastName, demandRecruiterFirstName },
    }),
  );
};

export const statusColorHandle = (status: DemandStatus): string => {
  switch (status) {
    case 'ACTIVE':
      return '#F5222D';
    case 'ON_HOLD':
      return '#BFBFBF';
    case 'STAFFED':
      return '#1F3C5E';
    default:
      return '#DFF9D2';
  }
};
